export class AccessTokenMissingException {
}
//# sourceMappingURL=access-token-missing.exception.js.map